import { extendObservable, action } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import NotificationService from '../../../core/services/NotificationService';
import { isRequired } from '../../../core/validations';
import { browserHistory } from 'react-router';

export default class LocalizationFormService {
  fetch = new FetchService();
  submit = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      localizationId: null,
      segments: [],
    });
    this.form.validations = {
      key: [isRequired],
      type: [isRequired],
    };
  }

  handleLoad = action(async (localizationId) => {
    this.form.reset();
    this.form.setInitialValues({});

    if (localizationId) {
      await this.fetch.fetch({
        url: `/localization-items/${localizationId}`,
      });
      if (this.fetch.data) {
        this.form.setInitialValues(this.fetch.data);
      }
    }

    this.segments = await this.fetch.fetch({
      url: '/segments',
    });
    const locales = await this.fetch.fetch({
      url: '/locales',
    });
    this.form.setInitialValues({
      ...this.form.getValues(),
      translations: locales.reduce((acc, locale) => {
        const defaultTranslation = (this.form.getValue('translations') || []).find(
          (translation) => translation.locale === locale.key && !translation.segment
        );

        return [
          ...acc,
          {
            locale: locale.key,
            value: (defaultTranslation && defaultTranslation.value) || undefined,
          },
          ...this.segments.map((segment) => {
            const segmentTranslation = (this.form.getValue('translations') || []).find(
              (translation) => translation.locale === locale.key && translation.segment === segment.id
            );

            return {
              locale: locale.key,
              segment: segment.id,
              value: (segmentTranslation && segmentTranslation.value) || undefined,
            };
          }),
        ];
      }, []),
    });
    this.localizationId = localizationId;
  });

  handleSubmit = action(() => {
    this.form.submitted = true;
    if (this.form.errors) {
      NotificationService.addNotification('Fill the required fields', 'error');
      return;
    }
    const localizationId = this.form.getValue('id');
    this.submit
      .fetch({
        method: localizationId ? 'put' : 'post',
        url: localizationId ? `/localization-items/${localizationId}` : '/localization-items',
        body: {
          ...this.form.getValues(),
          translations: this.form
            .getValue('translations')
            .filter((translation) => translation.value !== null && translation.value !== undefined),
        },
      })
      .then(() => {
        if (this.submit.data) {
          browserHistory.push('/localization');
          NotificationService.addNotification(
            `Localization Item ${localizationId ? 'updated' : 'created'} successfully.`,
            'success'
          );
        }
        if (this.submit.error) {
          NotificationService.addNotification(
            `Error ${localizationId ? 'updating' : 'creating'} localization Item.`,
            'error'
          );
        }
      });
  });
}
